import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {current, historical, redirect} from "./EventUtils";
import {
  initEvent,
  removeDataParams,
  setBase,
} from "../../reducers/EventSlice";
import {getSourceWithMeasure, makeSelectField} from "../../utils/common";
import Select from "react-select";
import DataParamCreation from "./DataParamCreation";
import TimeParamCreation from "./TimeParamCreation";
import ComputationParamCreation from "./ComputationParamCreation";
import Button from "../../components/Selectors/Button";
import {useNavigate} from "react-router-dom";
import {addEvent} from "../../network/DataManagementApi";

const AnalyticalFormulaEvent = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const init = {
    current: structuredClone(current),
    historical: structuredClone(historical),
  };

  const selectedSource = useSelector((state) => state.event.selectedSource);
  const data = useSelector((state) => state.event);

  const source = useSelector((state) => state.event.source);
  const sourceId = useSelector((state) => state.event.sourceId);
  const configurations = useSelector((state) => state.data.configured_source);
  useEffect(() => {
    dispatch(
      initEvent({
        data: structuredClone(init),
        source: getSourceWithMeasure("crude_source"),
        selectedSource: null,
        histo: false,
        count: true,
        sourceId: false,
        lockedHisto: true,
      })
    );
    setLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const create = () => {
    const state = structuredClone(data);
    const formattedData = {};
    formattedData["module_name"] = "Analyticalformula";
    formattedData["function_name"] = "process";
    formattedData["parameters"] = {
      computation_params: state.data.current.computation_params,
      data_params: state.data.current.data_params,
      time_params: state.data.current.time_params,
    };
    addEvent(formattedData, () => history(redirect));
  };
  return (
    <div>
      {loaded && (
        <div>
          <div className="bg-white  pt-4 pb-8 px-8 m-8  shadow-lg rounded-lg">
            <h2 className="text-theme1 text-2xl font-semibold">
              Paramètres des données
            </h2>
            <label className="text-sm font-bold text-gray-700 dark:text-white tracking-wide">
              Source de données
            </label>
            <Select
              placeholder={"Source de données..."}
              openMenuOnClick={false}
              isClearable={true}
              isMulti={true}
              value={selectedSource}
              options={makeSelectField(source, ["name"])}
              isDisabled={sourceId}
              isLoading={sourceId}
              onChange={(option, action) => {
                if (action.action === "remove-value") {
                  const measure_identifier =
                    configurations[
                      source[action.removedValue.value].configuration[0]
                      ].measure_identifier;
                  dispatch(removeDataParams(measure_identifier));
                  dispatch(setBase({type: "selectedSource", value: option}));
                  dispatch(setBase({type: "selectedSource", value: option}));
                }
                if (action.action === "select-option") {
                  dispatch(setBase({type: "selectedSource", value: option}));
                  dispatch(
                    setBase({type: "sourceId", value: action.option.value})
                  );
                }
              }}
            />
            {sourceId && <DataParamCreation/>}
          </div>
          <TimeParamCreation/>
          <ComputationParamCreation/>
        </div>
      )}
      <div className="grid grid-cols-7 gap-4 pt-2">
        <span className="col-span-3"/>
        <Button label={"Créer"} disabled={false} callback={create}/>
      </div>
    </div>
  );
};
export default AnalyticalFormulaEvent;
